<ion-content color="primary">
  <div class="flex align-items-center justify-content-center m-0 w-full h-full relative p-16">
    <div class="text-container flex flex-column align-items-center" *ngIf="status$ | async">
      <h1 class="fs-28 font-medium text-center" *ngIf="(failed$ | async) === false">
        {{ 'pages.fund-cash.purchase.payment.title' | translate }}
      </h1>
      <div class="shadow-icon flex flex-column justify-content-center align-items-center">
        <svg width="150" height="150" *ngIf="(expired$ | async) === false">
          <circle
            class="progress"
            cx="75"
            cy="75"
            r="60"
            stroke-width="6"
            fill="none"
            [attr.stroke-dasharray]="circumference"
            [attr.stroke-dashoffset]="dashOffset$ | async"
          ></circle>
        </svg>
        <ion-icon *ngIf="(failed$ | async) === false" name="card-outline" [class.expired]="expired$ | async"></ion-icon>
        <ion-icon *ngIf="failed$ | async" name="alert-outline"></ion-icon>
      </div>

      <ng-container *ngIf="(expired$ | async) === false && (failed$ | async) === false">
        <h1 class="fs-24 font-medium text-center mb-0">{{ remainingString$ | async }}</h1>
        <p class="fs-16 font-medium text-center">{{ 'pages.fund-cash.purchase.payment.expirationDescription' | translate }}</p>

        <ng-container *ngIf="cardSpendingLimits$ | async as limits">
          <span *ngIf="limits?.dailyLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.daily' | translate: { limit: (limits.dailyLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.weeklyLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.weekly' | translate: { limit: (limits.weeklyLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.monthlyLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.monthly' | translate: { limit: (limits.monthlyLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.yearlyLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.yearly' | translate: { limit: (limits.yearlyLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.allTimeLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.allTime' | translate: { limit: (limits.allTimeLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.perAuthorizationLimit" class="font-regular w-full ion-text-center">
            {{
              'pages.fund-cash.purchase.form.cardLimit.perAuthorization'
                | translate: { limit: (limits.perAuthorizationLimit | currency: 'EUR') }
            }}
          </span>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="expired$ | async">
        <h1 class="fs-24 font-medium text-center mb-0">{{ 'pages.fund-cash.purchase.payment.expired' | translate }}</h1>
        <ion-button expand="block" class="reactivate-button" [disabled]="isActivatingCard$ | async" (click)="refreshCard()">
          <ion-icon slot="start" name="refresh-circle"></ion-icon>
          {{ 'pages.fund-cash.purchase.payment.reactivate' | translate }}
        </ion-button>
      </ng-container>

      <ng-container *ngIf="failed$ | async">
        <h1 class="fs-24 font-medium text-center mb-0">{{ 'pages.fund-cash.purchase.payment.failed' | translate }}</h1>
      </ng-container>
    </div>

    <ion-button class="absolute x-16 b-16 font-medium" color="secondary" mode="ios" (click)="close()">
      {{ 'pages.fund-cash.purchase.payment.cancel' | translate }}
    </ion-button>
  </div>
</ion-content>
